import { inject, Injectable } from "@angular/core";

import { AppConstants } from "@mp/app.constants";
import { StorageService } from "@mp/core/services/storage.service";
import { BaseService } from "../base/base.service";
import { DateUtil } from "../helpers/date-util";

@Injectable({
    providedIn: "root"
})
export class DateToolsService extends BaseService {
    private readonly storageService = inject(StorageService);

    public selectWeekStartDate(givenWeekStart: Date | string): void {
        let weekStart: Date;
        if (typeof givenWeekStart === "string") {
            weekStart = new Date(givenWeekStart);
        } else {
            weekStart = givenWeekStart;
        }
        this.storageService.setItem(AppConstants.StorageKeys.USER.WEEK, weekStart.toISOString());
    }

    public getSelectedWeekStartDate(): Date {
        const weekStartFromStorage = this.storageService.getItem(AppConstants.StorageKeys.USER.WEEK);
        if (weekStartFromStorage) {
            return new Date(weekStartFromStorage);
        }
        const week = DateUtil.getWeekOfToday();
        const weekStart = typeof week.start === "string" ? new Date(week.start) : week.start;
        this.selectWeekStartDate(weekStart);
        return weekStart;
    }

    public getSelectedYear(): number {
        const weekStartDate = this.getSelectedWeekStartDate();
        const week = DateUtil.calculateWeekStartAndEndDates(weekStartDate);
        const weekStart = typeof week.start === "string" ? new Date(week.start) : week.start;

        // ISO 8601: The year of the week is the year of the Thursday
        const thursday = new Date(weekStart);
        thursday.setDate(weekStart.getDate() + 3);
        return thursday.getFullYear();
    }

    public clearSelectedWeek(): void {
        this.storageService.removeItem(AppConstants.StorageKeys.USER.WEEK);
    }
}
